new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: '',
    },
    methods: {
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                let photoListItem = document.querySelectorAll('#photo-list li');
                let singlePhotoItem = document.querySelectorAll('#product-photo img');

                if(photoListItem.length && singlePhotoItem.length) {
                    photoListItem[0].classList.add('active');
                    singlePhotoItem[0].classList.add('active');

                    function activeTab(index) {
                        singlePhotoItem.forEach((content) => {
                          content.classList.remove('active');
                        });
                        singlePhotoItem[index].classList.add('active');
                    }
    
                    photoListItem.forEach((itemMenu, index) => {
                        itemMenu.addEventListener('click', () => {
                          activeTab(index);
                        });
                    });
                }
            }

            if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                $('#photo-list').slick({
                    infinite: false,
                    slidesToShow: 5,
                    vertical: true,
                    slidesToScroll: 1
                });
            }else if (photoThumbs.classList.contains('gallery-bottom')) {
                $('#photo-list').slick({
                    infinite: false,
                    slidesToShow: 4,
                    slidesToScroll: 1
                });
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        scrollSelect() {
            const scroll = document.querySelector('.product-detail__header--infoArea-kit');
            const sizes = scroll.querySelector('.product-radio-variation');
            if (scroll && sizes) {
                scroll.addEventListener('click', function() {
                    scroll.classList.toggle('active');
                });
                const allSizes = sizes.querySelectorAll('label');
                allSizes.forEach(size => {
                    size.addEventListener('click', () => {
                        scroll.classList.toggle('active');
                        scroll.setAttribute('content-label', size.textContent);
                    });
                });
            }

            // Seleciona o botão e o elemento para adicionar/remover a classe
            const buyButton = document.querySelector('.product-detail__header--infoArea  #buy-button');
            const productDetailBuyScroll = document.querySelector('.product-detail__buy-scroll');

            // Função de callback para o Intersection Observer
            const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                // Se o botão não está visível na tela, adiciona a classe 'active'
                productDetailBuyScroll.classList.add('active');
                } else {
                // Se o botão está visível na tela, remove a classe 'active'
                productDetailBuyScroll.classList.remove('active');
                }
            });
            };

            // Configuração do Intersection Observer
            const observerOptions = {
            root: null, // Observa em relação ao viewport
            threshold: 0 // Chama o callback quando qualquer parte do alvo não está visível
            };

            // Cria um novo Intersection Observer
            const observer = new IntersectionObserver(observerCallback, observerOptions);

            // Começa a observar o botão
            observer.observe(buyButton);

        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();
            
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
            const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.clickThumbs();
        this.scrollSelect();
        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if(ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                    ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

    const customSelects = document.querySelectorAll('.custom-select-container .custom-select');

    customSelects.forEach(select => {
        const display = select.querySelector('.select-display');
        const dropdown = select.querySelector('.select-dropdown');
        const searchInput = select.querySelector('.select-search');
        const options = select.querySelectorAll('.select-options li');

        // Adiciona texto inicial baseado na opção selecionada
        const selectedOption = select.querySelector('.select-options .selected');
        if (selectedOption) {
            display.textContent = selectedOption.textContent; // Define o texto inicial do display
        } else {
            display.textContent = ''; // Se não houver seleção, mantém vazio
        }

        // Mostra/oculta o dropdown ao clicar
        display.addEventListener('click', () => {
            select.classList.toggle('active');
            dropdown.style.display = select.classList.contains('active') ? 'block' : 'none';
            searchInput.value = ''; // Limpa a busca ao abrir
            filterOptions(''); // Reseta o filtro
        });

        // Fecha o dropdown ao clicar fora
        document.addEventListener('click', (event) => {
            if (!select.contains(event.target)) {
                select.classList.remove('active');
                dropdown.style.display = 'none';
            }
        });

        // Filtra opções com base na busca
        searchInput.addEventListener('input', () => {
            const filter = searchInput.value.toLowerCase();
            filterOptions(filter);
        });

        // Filtra as opções com base no texto da busca
        function filterOptions(filter) {
            options.forEach(option => {
                const text = option.textContent.toLowerCase();
                option.style.display = text.includes(filter) ? '' : 'none';
            });
        }

        // Seleciona uma opção ao clicar
        options.forEach(option => {
            option.addEventListener('click', () => {
                display.textContent = option.textContent; // Atualiza o texto exibido
                select.classList.remove('active');
                dropdown.style.display = 'none';
                // Redireciona para o URL do produto
                window.location.href = option.dataset.value; // Redireciona para o URL do produto
            });
        });
    });

    // waitForElementToExist('.custom-select').then(element => {
    //     const customSelects = document.querySelectorAll('.custom-select');

    //     if (customSelects) {
    //         customSelects.forEach(select => {
    //             const display = select.querySelector('.select-display'),
    //                   dropdown = select.querySelector('.select-dropdown'),
    //                   searchInput = select.querySelector('.select-search');
                
    //             let isDropdownOpen = false;

    //             if (display && dropdown && searchInput) {
    //                 const options = dropdown.querySelectorAll('.select-options li');

    //                 display.addEventListener('click', function(event) {
    //                     event.stopPropagation();
    //                     isDropdownOpen = !isDropdownOpen;
    //                     dropdown.classList.toggle('active', isDropdownOpen);
    //                 });

    //                 document.addEventListener('mousedown', function(e) {
    //                     if (!select.contains(e.target) && isDropdownOpen) {
    //                         dropdown.classList.remove('active');
    //                         isDropdownOpen = false;
    //                     }
    //                 });

    //                 searchInput.addEventListener('input', function() {
    //                     const filter = searchInput.value.toLowerCase();
    //                     options.forEach(option => {
    //                         const text = option.textContent.toLowerCase();
    //                         if (text.includes(filter)) {
    //                             option.style.display = '';
    //                         } else {
    //                             option.style.display = 'none';
    //                         }
    //                     });
    //                 });

    //                 options.forEach(option => {
    //                     option.addEventListener('click', function() {
    //                         const selectedValue = this.getAttribute('data-value');
    //                         display.textContent = this.textContent;
                    
    //                         // Remove a classe 'selected' de todos os options
    //                         options.forEach(opt => {
    //                             opt.classList.remove('selected');
    //                         });
                    
    //                         // Adiciona a classe 'selected' ao option que foi clicado
    //                         this.classList.add('selected');

    //                         selectProduct(option.getAttribute('data-value'));

    //                         const priceFull = document.querySelectorAll('.product-detail__header--infoArea-price .price-full');
    //                         if (priceFull) {
    //                             priceFull.forEach(price => {
    //                                 price.innerHTML = 'R$' + option.getAttribute('data-product-variation-price');
    //                             })
    //                         }
                    
    //                         // Fecha o dropdown após a seleção
    //                         dropdown.classList.remove('active');
    //                         isDropdownOpen = false;
    //                     });
    //                 });
                    
    //             }

    //         });
    //     }
    // });

    // function selectProduct(id) {
    //     axios.get(`/api/front/product/${id}/get-linked-product/`)
    //     .then(res => {
    //         const allNames = document.querySelectorAll('span[id^="js-product_name__product_detail_"]');
    //         allNames.forEach(item => {
    //             item.innerHTML = res.data.name;
    //         });

    //         const keepingBuyingName = document.querySelector('#js-product_name__product_detail_keeping_buying');
    //         const keepingBuyingImage = document.querySelector('.keeping-buying__figure--image');
    //         if (keepingBuyingName && keepingBuyingImage) {
    //             keepingBuyingName.innerHTML = res.data.name;
    //             keepingBuyingImage.setAttribute('src', `${res.data.images[0]}`);
    //         }

    //         $('.product-detail__header--photoArea-mobile').slick('removeSlide', null, null, true);
    //         $('.product-detail__header--photoArea-photo ul').html('');
    //         if (res.data.images.length > 0) {
    //             for (i = 0; i <= res.data.images.length - 1; i++) {
    //                 $('.product-detail__header--photoArea-mobile').slick('slickAdd', `<li style="width: 100%; display: inline-block;"><a href="${res.data.images[i]}"><img src="${res.data.images[i]}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
    //                 $('.product-detail__header--photoArea-photo ul').append(`<li style="width: 100%; display: inline-block;"><a href="${res.data.images[i]}" data-fancybox="gallery1"><img src="${res.data.images[i]}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
    //             }
    //         }

    //         const getBody = document.querySelector('body');
    //         getBody.setAttribute('data-id', `${id}`);
    //         getBody.setAttribute('data-id-current', `${id}`);

    //     })
    //     .catch(err => {
    //         console.log(err);
    //     });
    // }

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    })

    $('#product-detail-related-carrousel').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 2,
        slidesPerRow: 2,
        speed: 700,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                    slidesToShow: 4,
                    rows: 1,
                    slidesPerRow: 1,
                }
            }
        ]
    })

    $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });

    $('.product__colors.attribute').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#photo-fancy').fancybox();


    const descripTipo2 = document.querySelector('.product-detail__description-tipo-2');
    if (descripTipo2) {
        const allDescriptions = descripTipo2.querySelectorAll('.product-detail__description-tipo-2__item');
    
        allDescriptions.forEach((item) => {
            const itemContent = item.querySelector('.product-detail__description-tipo-2__content'),
                  itemHeight = item.clientHeight + 'px';
            itemContent.style.height = itemHeight;
            itemContent.classList.remove('calc');
            item.addEventListener('click', function() {
                const removeClass = descripTipo2.querySelector('.product-detail__description-tipo-2__item.active');
                if (removeClass) {
                    removeClass.classList.remove('active');
                }
                item.classList.toggle('active');
            });
        });
    }

    const descripTipo3 = document.querySelector('.product-detail__description-tipo-3');
    if (descripTipo3) {
        const allDescriptions = descripTipo3.querySelectorAll('.product-detail__description-tipo-3__item');
        allDescriptions.forEach((item) => {
            item.addEventListener('click', function() {
                descripTipo3.querySelector('.product-detail__description-tipo-3__item.active').classList.remove('active');
                descripTipo3.querySelector('.product-detail__description-tipo-3__content.active').classList.remove('active');
                item.classList.toggle('active');
                descripTipo3.querySelector(`.js_product_detail_description-tipo-3_content_${item.getAttribute('data-id')}`).classList.add('active');
            });
        })

    }
    


})